module.exports = __webpack_public_path__ + "img/help26.300856a3.png";